import React from "react";
import { Stack, Center, SimpleGrid, Box, Text } from "@chakra-ui/react";
import { IconType } from "@onemind-services-llc/react-icons-ng";
import rocketImage from "public/home/rocket.svg";

type ListLayoutProps = {
  data: { content: string; icon: IconType }[];
  isDefault?: boolean;
};

const ListLayout = ({ data, isDefault = true }: ListLayoutProps) => {
  const midpoint = Math.ceil(data.length / 2);
  const list1 = data.slice(0, midpoint);
  const list2 = data.slice(midpoint);

  return (
    <SimpleGrid
      gridTemplateColumns={{
        base: "1fr",
        sm: "1fr 1fr",
        md: "1fr 0.5fr 1fr",
      }}
      spacing={{ base: 6, sm: 8 }}
      paddingX={"10px"}
      data-cy={"section-features"}
    >
      <div data-cy="list-layout-container-1">
        {list1.map((item, index) => {
          const { content } = item;
          const isEven = index % 2 === 0;
          return (
            <Box key={index} display="flex" paddingBottom="20px">
              <Stack
                alignItems={"center"}
                direction={{ base: "column", sm: "row-reverse" }}
                spacing={4}
                flex="1"
              >
                <Center
                  bg={isEven ? "brand.100" : "black"}
                  borderRadius="50%"
                  h="50px"
                  minH={"50px"}
                  minW={"50px"}
                  w="50px"
                >
                  <item.icon color="white" fontSize="25px" />
                </Center>

                <Text
                  fontWeight={"600"}
                  textAlign={{ base: "center", sm: "end" }}
                  fontSize={{ base: "lg", lg: "xl" }}
                  color={"gray.600"}
                >
                  {content}
                </Text>
              </Stack>
            </Box>
          );
        })}
      </div>

      <Stack display={{ base: "none", md: "flex" }} justifyContent={"center"}>
        <Box
          backgroundImage={rocketImage.src}
          backgroundPosition={"center center"}
          backgroundSize={"cover"}
          w={"100%"}
          height={"100%"}
        />
      </Stack>

      <div data-cy="list-layout-container-2">
        {list2.map((item, index) => {
          const { content } = item;
          const isEven = index % 2 === 0;

          return (
            <Box key={index} display="flex" paddingBottom="20px" width={"100%"}>
              <Stack
                width={"100%"}
                alignItems="center"
                direction={{ base: "column", sm: isDefault ? "row" : "row-reverse" }}
                justifyContent={isDefault ? "start" : "end"}
                spacing={4}
              >
                <Center
                  bg={isEven ? "brand.100" : "black"}
                  borderRadius="50%"
                  h="50px"
                  minH={"50px"}
                  minW={"50px"}
                  w="50px"
                >
                  <item.icon color="white" fontSize="25px" />
                </Center>
                <Text
                  fontWeight={"600"}
                  textAlign={{ base: "center", sm: isDefault ? "start" : "end" }}
                  fontSize={{ base: "lg", lg: "xl" }}
                  color={"gray.600"}
                >
                  {content}
                </Text>
              </Stack>
            </Box>
          );
        })}
      </div>
    </SimpleGrid>
  );
};

export default ListLayout;
